import { NgModule } from "@angular/core";
import { IonicModule } from "ionic-angular";
import { TooltipsModule } from "ionic-tooltips";
import { TooltipComponent } from "../tooltip/tooltip";
@NgModule({
  declarations: [TooltipComponent],
  imports: [IonicModule, TooltipsModule],
  exports: [TooltipComponent],
})
export class TooltipModule {}



// WEBPACK FOOTER //
// ./src/tooltip/tooltip.module.ts